import { render, staticRenderFns } from "./FigmaIntent.vue?vue&type=template&id=0501759c&scoped=true&"
import script from "./FigmaIntent.vue?vue&type=script&lang=js&"
export * from "./FigmaIntent.vue?vue&type=script&lang=js&"
import style0 from "./FigmaIntent.vue?vue&type=style&index=0&id=0501759c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501759c",
  null
  
)

export default component.exports